function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyRoadmap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 63,
    height: 31,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 12.144 167)",
    fill: "#BFC1C4",
    stroke: "#808389",
    style: {
      fill: "#BFC1C4",
      fill: "color(display-p3 0.7490 0.7569 0.7686)",
      fillOpacity: 1,
      stroke: "#808389",
      stroke: "color(display-p3 0.5020 0.5137 0.5373)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 111,
    height: 31,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 44.144 115)",
    fill: "#E6E6E7",
    stroke: "#ABACB1",
    style: {
      fill: "#E6E6E7",
      fill: "color(display-p3 0.9020 0.9020 0.9059)",
      fillOpacity: 1,
      stroke: "#ABACB1",
      stroke: "color(display-p3 0.6706 0.6745 0.6941)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 63,
    height: 31,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 124.144 63)",
    fill: "#808389",
    stroke: "#565962",
    style: {
      fill: "#808389",
      fill: "color(display-p3 0.5020 0.5137 0.5373)",
      fillOpacity: 1,
      stroke: "#565962",
      stroke: "color(display-p3 0.3373 0.3490 0.3843)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRoadmap);
export default __webpack_public_path__ + "static/media/empty-roadmap.3cd5c4a8a04a1561addba03b7f6b3d28.svg";
export { ForwardRef as ReactComponent };